// extracted by mini-css-extract-plugin
export default {"maincontainer":"AccessControl_maincontainer__nkRz3","forstatus":"AccessControl_forstatus__afQL4"};